import React from 'react';
import PT from 'prop-types';
import cn from 'classnames';

import BaseInput from 'Components/Input';
import getCurrencySymbol from 'Shared/util/getCurrencySymbol';

const Currency = ({ currency, inputType, fieldProps: { value, onChange, ...fieldProps }, ...props }) => {
  const valueIsNotEmpty = () => value || value === 0;
  const handleChange = (e) => onChange(e.target.value < 0 ? 0 : e.target.value);

  return (
    <BaseInput
      prefix={currency && valueIsNotEmpty() ? getCurrencySymbol(currency) : undefined}
      fieldProps={{
        value,
        type: 'number',
        onChange: handleChange,
        ...fieldProps,
      }}
      className={cn('currency-field', { 'currency-field_value': valueIsNotEmpty() })}
      {...props}
    />
  );
};

Currency.propTypes = {
  inputType: PT.oneOf(['text', 'number', 'email', 'password']),
};

export default Currency;
